import ContactForm, { IContact } from 'components/ContactForm';
import { ChangeEvent } from 'react';
import styled from 'styled-components';
import { SectionTextWrapper } from 'styles/global.styles';

interface IContactSection {
  data: IContact;
  onSubmit: (data: IContact) => void;
  onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  errors: IContact;
}

const ContactSection = (props: IContactSection): JSX.Element => {
  return (
    <Wrapper>
      <SectionTextWrapper sectionNumber={5} heading="Kontaktuppgifter" />

      <ContactForm
        onSubmit={props.onSubmit}
        data={props.data}
        onChange={props.onChange}
        errors={props.errors}
      />
    </Wrapper>
  );
};

export default ContactSection;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 2rem;
`;
